export class Address {
  company: string;
  firstName: string;
  lastName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  postal: string;
  phone: string;
  country: string;
  pseq: number | null;
  tenantId: string;
}
